module.exports = "<div class=\"modal-dialog modal-dialog-centered modeldiv\">\n  <div class=\"modal-content contentdiv\">\n    <div class=\"modal-body\">\n      <div class=\"form-group row\">\n        <div *ngIf=\"loading\">\n          <div class=\"se-pre-con\"></div>\n          <label class=\"col-sm-12 col-form-label statusLabel\">{{ProgressText}}</label>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/zatcatransaction/zatcatransaction.component.html
// module id = ../../../../../src/app/shared/component/zatcatransaction/zatcatransaction.component.html
// module chunks = main